// extracted by mini-css-extract-plugin
module.exports = {"sticky":"covidWarning_sticky__t_iPN","background":"covidWarning_background__q6Pag","content":"covidWarning_content__ydgQS"};